
import { useState, useEffect } from "react";

// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
//import Menu from "@mui/material/Menu";

// Material Dashboard 2 React components
import MDBox from "../MDBox";
import ManualAyuda from "../ManualAyuda";
import ResumenGestionBanner from "../ResumenGestionBanner";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "../DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "../../../context";
import { Home, Menu, Settings } from "@mui/icons-material";
import MDTypography from "../MDTypography";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  // const [openMenu, setOpenMenu] = useState(false);
  // const route = useLocation().pathname.split("/").slice(1);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("static");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenConfigurator = () => setOpenConfigurator(dispatch, true);
  
  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {/* <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox> */}
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "warning" : "warning"}>

              <Link to="/Login">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  {/* <Icon sx={iconsStyle}>account_circle</Icon> */}
                  <Home />
                </IconButton>
              </Link>

              <IconButton
                size="small"
                disableRipple
                color="warning"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                {/* <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon> */}
                <Menu />
              </IconButton>
              <IconButton sx={navbarIconButton} size="small" disableRipple onClick={handleOpenConfigurator}>
                <Settings />
              </IconButton>
              <ManualAyuda soloCompleto iconColor="inherit" />

              <MDBox color={light ? "warning" : "warning"}>
              <MDTypography display="block" variant="caption" color="text" fontWeight="light">
                {localStorage.getItem('nameuserlogueado')}<br />
                {localStorage.getItem('userlogueado')}
              </MDTypography>
              </MDBox>
              <MDBox color={light ? "info" : "info"}>
              <MDTypography display="block" variant="caption" color="text" fontWeight="light">
                {localStorage.getItem('nombrePerfil')}<br />
              </MDTypography>
            </MDBox>
          </MDBox>
          </MDBox>
        )}
        {/* Resumen del usuario logueado (gestiones de hoy, horario, casos del mes y puntaje), a la derecha de la barra */}
        {isMini ? null : <ResumenGestionBanner />}
    </Toolbar>
    </AppBar >
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
